
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { BaseIconComponent } from '../../private/base-icon/base-icon.component';

@Component({
  selector: 'icon-check',
  imports: [],
  templateUrl: './check-icon.component.html',
  styleUrl: '../styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckIconComponent extends BaseIconComponent {
  readonly circle = input(false);
}
